import Vue from 'vue';
import Vuelidate from 'vuelidate';
import VModal from 'vue-js-modal/dist/index.nocss.js';
import VTooltip from 'v-tooltip';
import VueCurrencyFilter from 'vue-currency-filter';

import Vue2TouchEvents from 'vue2-touch-events';
import VueLazyLoad from 'vue-lazyload';
import VueParallaxJs from 'vue-parallax-js'

// Components
const SiteHeader = () => import('./components/SiteHeader');
const Tabs = () => import('./components/Tabs');
const VideoModalButton = () => import('./components/VideoModalButton');
const LogoSvg = () => import('../../svg/logo.svg');
import VideoEmbed from './components/VideoEmbed';
import EnrolmentForm from './components/forms/EnrolmentForm.vue';
import Loader from './components/Loader.vue';

// Store
import store from './_vue-store';

Vue.use(Vue2TouchEvents, {
    disableClick: true
});
Vue.use(VueParallaxJs);
Vue.use(VueLazyLoad);
Vue.use(Vuelidate);

Vue.use(VTooltip, {
    defaultContainer: '.enrolment-form-wrap',
    defaultTrigger: 'hover click'
});

Vue.use(VueCurrencyFilter, {
    symbol: '£',
    thousandsSeparator: ',',
    fractionCount: 2,
    fractionSeparator: '.',
    symbolPosition: 'front',
    symbolSpacing: false
})

Vue.use(VModal, {
    dynamicDefaults: {
        height: 'auto',
        adaptive: true,
        scrollable: true,
        clickToClose: false
    }
});

new Vue({
    el: '#app',
    store: store,
    components: { 
        SiteHeader,
        LogoSvg,
        Tabs,
        VideoModalButton,
        EnrolmentForm,
        Loader,
        VideoEmbed
    }
})